/**
 * Shared settled-summary helpers for graph mutation cards (legacy
 * `cypher_write` and structured `graph_write`).
 */
import type {
  AgentActionTerminalState,
  GraphMutationAppliedCounts
} from '@axilon-apps/domains-ontology-ui-state'

export function formatAppliedCounts(counts: GraphMutationAppliedCounts | undefined): string | null {
  if (!counts) return null
  const parts: string[] = []
  if (counts.nodesCreated && counts.nodesCreated > 0) parts.push(`+${counts.nodesCreated} node`)
  if (counts.nodesModified && counts.nodesModified > 0) parts.push(`~${counts.nodesModified} node`)
  if (counts.nodesDeleted && counts.nodesDeleted > 0) parts.push(`−${counts.nodesDeleted} node`)
  if (counts.relationshipsCreated && counts.relationshipsCreated > 0)
    parts.push(`+${counts.relationshipsCreated} rel`)
  if (counts.relationshipsDeleted && counts.relationshipsDeleted > 0)
    parts.push(`−${counts.relationshipsDeleted} rel`)
  return parts.length > 0 ? parts.join(', ') : null
}

export interface GraphMutationSettledProposal {
  appliedCounts?: GraphMutationAppliedCounts
  rejectionReason?: string
  terminalState?: AgentActionTerminalState
}

export function GraphMutationSettledSummary({
  proposal
}: {
  proposal: GraphMutationSettledProposal
}) {
  const terminal = proposal.terminalState
  if (!terminal) return null
  if (terminal.kind === 'applied') {
    const summary = formatAppliedCounts(proposal.appliedCounts)
    return (
      <p className="px-1 text-10 text-emerald-600 dark:text-emerald-400">
        Applied{summary ? ` — ${summary}` : ''}.
      </p>
    )
  }
  if (terminal.kind === 'apply_failed') {
    return <p className="px-1 text-10 text-destructive">Apply failed — {terminal.error}</p>
  }
  return (
    <p className="px-1 text-10 text-muted-foreground">
      Rejected{proposal.rejectionReason ? ` — ${proposal.rejectionReason}` : ''}.
    </p>
  )
}
